import { Container } from '@/components/Container';
import { useTranslation } from '@/hooks/useTranslation';

/* ═══════════════════════════════════════════
   SEGURANÇA — Avisos e telefones úteis
   ═══════════════════════════════════════════ */

const telefones = [
  // TODO: URGENTE — substituir pelo número real do salva-vidas antes do deploy
  // Confirmar com Josirley
  { id: 'lifeguard', num: '(41) 99999-9999' }, // PLACEHOLDER - NÃO FAZER DEPLOY COM ESTE NÚMERO
  { id: 'healthBrasilia', num: '(41) 3455-1234' },
  { id: 'healthEncantadas', num: '(41) 3455-5678' },
  { id: 'police', num: '190' },
  { id: 'firefighters', num: '193' },
  { id: 'navy', num: '(41) 3453-2345' },
];

const riscos = [
  { id: 'tide', icon: '🌊', cor: 'bg-ocean-50 border-ocean-200' },
  { id: 'bugs', icon: '🦟', cor: 'bg-coral/5 border-coral/20' },
  { id: 'sunburn', icon: '☀️', cor: 'bg-amber-50 border-amber-200' },
  { id: 'noHospital', icon: '🏥', cor: 'bg-red-50 border-red-200' },
  { id: 'signal', icon: '📵', cor: 'bg-sand-50 border-sand-300' },
  { id: 'wildlife', icon: '🐍', cor: 'bg-teal-50 border-teal-200' },
];

export function SegurancaSection() {
  const { t } = useTranslation();

  return (
    <section id="seguranca" className="py-16 sm:py-20 bg-white">
      <Container>
        {/* Header */}
        <div className="text-center mb-12">
          <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
            {t('guide.safety.overline')}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-2">
            {t('guide.safety.title')}
          </h2>
          <p className="font-editorial text-lg text-warm-gray mt-2 max-w-2xl mx-auto">
            {t('guide.safety.description')}
          </p>
        </div>

        {/* Riscos grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
          {riscos.map(r => (
            <div key={r.id} className={`rounded-2xl border p-6 ${r.cor}`}>
              <span className="text-3xl mb-3 block">{r.icon}</span>
              <h3 className="font-display text-lg text-warm-dark mb-2">
                {t(`guide.safety.risks.${r.id}.title`)}
              </h3>
              <p className="font-body text-sm text-warm-gray leading-relaxed">
                {t(`guide.safety.risks.${r.id}.desc`)}
              </p>
            </div>
          ))}
        </div>

        {/* Telefones úteis */}
        <div className="max-w-2xl mx-auto">
          <h3 className="font-display text-2xl text-warm-dark mb-6 text-center">
            {t('guide.safety.phonesTitle')}
          </h3>
          <div className="bg-white rounded-2xl border border-sand-200 overflow-hidden">
            <table className="w-full font-body text-sm">
              <tbody>
                {telefones.map((tItem, i) => (
                  <tr
                    key={tItem.id}
                    className={`border-b border-sand-100 ${i % 2 === 0 ? 'bg-white' : 'bg-sand-50/50'}`}
                  >
                    <td className="py-3 px-5 font-semibold text-warm-dark">
                      {t(`guide.safety.phones.${tItem.id}.name`)}
                    </td>
                    <td className="py-3 px-5 font-display text-lg text-teal-deep">{tItem.num}</td>
                    <td className="py-3 px-5 text-warm-gray text-xs">
                      {t(`guide.safety.phones.${tItem.id}.obs`)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="font-body text-xs text-warm-gray text-center mt-3">
            {t('guide.safety.phonesNote')}
          </p>

          {/* Informação sobre emergências médicas graves */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex gap-3 mt-4">
            <span role="img" aria-label="Hospital" className="text-xl flex-shrink-0">
              🏥
            </span>
            <div>
              <p className="font-body text-sm font-semibold text-warm-dark">
                Em caso de emergência médica grave
              </p>
              <p className="font-body text-sm text-warm-gray">
                O Posto de Saúde de Nova Brasília atende em horário comercial. Para casos graves, a
                remoção é feita por lancha (até Pontal do Sul) ou helicóptero. Acionamento: SAMU 192
                ou Bombeiros 193.
              </p>
            </div>
          </div>

          {/* Correntes de retorno */}
          <div className="bg-teal-50 border border-teal-200 rounded-xl p-4 flex gap-3 mt-3">
            <span role="img" aria-label="Onda" className="text-xl flex-shrink-0">
              🌊
            </span>
            <div>
              <p className="font-body text-sm font-semibold text-warm-dark">Correntes de retorno</p>
              <p className="font-body text-sm text-warm-gray">
                Praias de mar aberto (Farol, Praia de Fora) têm correntes de retorno. Se preso em
                uma: <strong>não nade contra a corrente</strong> — nade paralelamente à praia até
                sair da corrente, depois retorne. Prefira banhar em Nova Brasília se tiver crianças.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
